

import { HttpClient } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { BaseService, EnvironmentService } from 'tnx-shared';
@Injectable({
    providedIn: 'root'
})
export class ScheduleJobService extends BaseService {
    entityName = 'ScheduleJob';
    serviceCode = 'schedule';

    constructor(http: HttpClient, injector: Injector,
        private _environmentService: EnvironmentService) {
        super(http, injector, ``);
        this.endPoint = _environmentService.getHttpServiceEndpointWithVersion(this.serviceCode);
        this.serviceUri = `${this.endPoint}/${this.entityName}`;
    }

    //#region Global Quartz.Net

    async restartServer(data: any) {
        const url = `${this.serviceUri}/RestartServer`;
        return this.defaultPost(url, data);
    }

    //#endregion

    //#region Job

    async changeJobStatus(id: string, type: number) {
        const url = `${this.serviceUri}/ChangeJobStatus?id=${id}&type=${type}`;
        return this.defaultPost(url, null);
    }

    //#endregion
}
